import axios from "axios";
// const API_URL = 'http://localhost:8080/api';
// const API_URL = 'https://13.211.123.4/api';
const API_URL = 'https://phoenix-booking-backend.vercel.app/api';

// export const createTemporaryBooking = async (bookingDetails) => {
//   try {
//     await axios.post(API_URL + "/booking", {
//       bookingDetails, // status: "PENDING_PAYMENT"
//     }, {
//       timeout: 6000, // 6 seconds timeout
//     });
//   } catch (error) {
//     console.error("Error creating temporary booking", error);
//   }
// };

// Fetch booking details by date and status
export const fetchBookingDetails = async (date) => {
  try {
    const response = await axios.get( API_URL + '/bookings-by-date', {
      params: { status: "PENDING,PAID,RESERVED", date },
      timeout: 12000, // 12 seconds
    });
    return response.data.bookings; // Assuming the bookings are returned under this key
  } catch (error) {
    console.error("Error fetching booking details");
    throw error;
  }
};

export const fetchPaymentStatus = async (orderId) => {
  try {
    const response = await axios.get(`${API_URL}/payment/status`, {
      params: { order_id: orderId },
      timeout: 8000, // 8 seconds
    });
    return response.data; // response contains { success(true), status, details(success,payment,booking)}
  } catch (error) {
    console.error("Error fetching payment status");
    throw error; // Ensure errors are handled properly in the calling component
  }
};

export const fetchSecrets = async (bookingDetails) => {
  try {
    const response = await axios.post(`${API_URL}/payhere/hash`, {
      totalPrice: bookingDetails.totalPrice,
      courtId: bookingDetails.court.id,
    });

    return response.data; // { merchantId, orderId, hash }
  } catch (error) {
    console.error("Error generating hash");
    return null;
  }
};